/**
 * Formats an issue/PR reference based on the repository context.
 *
 * @param source - Source repository information containing number, ownerLogin, repoId, and repoName
 * @param targetRepoId - The target repository ID for comparison
 * @param targetOwnerLogin - The target owner login for comparison
 * @returns Formatted reference string:
 *   - `#123` if same repository
 *   - `repo-name#123` if different repository but same owner
 *   - `owner/repo-name#123` if different owner
 *
 * @example
 * ```typescript
 * formatIssueReference(
 *   { number: 123, ownerLogin: 'monalisa', repoId: '123456', repoName: 'smile' },
 *   '654321',
 *   'github'
 * ) // Returns: "monalisa/smile#123"
 * ```
 */
export function formatIssueReference(
  source: {
    number: number
    ownerLogin: string
    repoId: string
    repoName: string
  },
  targetRepoId: string | undefined,
  targetOwnerLogin: string | undefined,
): string {
  if (source.repoId === targetRepoId) {
    return `#${source.number}`
  }

  if (source.ownerLogin === targetOwnerLogin) {
    return `${source.repoName}#${source.number}`
  }

  return `${source.ownerLogin}/${source.repoName}#${source.number}`
}
